import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import ModalContainer from '@src/components/modal-container';
import PopMiniModalStore from './store';

const styles = require('./index.less');

/**
 * 组队微信小程序二维码弹窗
 */
const PopMiniModal = ({ store, onClose }) => {
  store.use();

  if (onClose) {
    store.onClose = onClose;
  }
  const TEST_URL = 'https://test-zt.xoyo.com/mechabreak.seasungames.cn/p/zt/2025/03/21/register/?reg_source=gcfab#/';
  // 灰度
  // const MASTER_URL = 'https://mechabreak.seasungames.cn/p/zt/2025/03/21/register-k29GLUuwgWdpNkDJIMPI/?reg_source=gcfab#/';
  // 正式
  const MASTER_URL = 'https://mechabreak.seasungames.cn/p/zt/2025/03/21/register/?reg_source=gcfab#/';
  const src = IS_MASTER_ENV ? MASTER_URL : TEST_URL;

  return (
    <ModalContainer modalState={store.isOpen}>
      <div className={cx(styles.registerModalRoot)}>
        <iframe src={src} className={styles.registerIframe} title="注册表单" frameborder="0" allowfullscreen scrolling="no" />
        <div className={styles.closeBtn} onClick={store.onClickClose} />
      </div>
    </ModalContainer>
  );
};

export default wrapStore(PopMiniModal, PopMiniModalStore);
